export { default } from './toPairs.js'



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/entries.js
// module id = 383
// module chunks = 0